import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'La Organización',
    desc: 'Usa nuestra Auditoría de 10 Minutos para organizar tus papeles antes de tocar una computadora.'
  }, {
    num: '02',
    title: 'El Portal',
    desc: 'Sigue el Mapa de Conexión Directa para entrar a los portales gratuitos del IRS.'
  }, {
    num: '03',
    title: 'El Envío',
    desc: 'Reclama tus deducciones y envía tu declaración electrónicamente por exactamente $0.'
  }];
  return <section className="bg-offwhite py-20 md:py-28" data-id="element-97">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
        <div className="text-center mb-16" data-id="element-99">
          <h2 className="text-4xl md:text-5xl font-bold text-navy-dark uppercase mb-4" data-id="element-100">
            Cómo Funciona
          </h2>
          <p className="text-xl text-gray-600 font-body" data-id="element-101">
            Tres pasos simples hacia tu libertad fiscal.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-102">
          {/* Connector line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-1 bg-gold-accent/30 z-0" data-id="element-103"></div>

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-104">
              <div className="w-24 h-24 rounded-full bg-navy-dark text-gold-accent flex items-center justify-center text-3xl font-bold font-heading mb-6 shadow-xl border-4 border-offwhite" data-id="element-105">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold text-navy-dark font-heading mb-4" data-id="element-106">
                {step.title}
              </h3>
              <p className="text-gray-700 font-body text-lg px-4" data-id="element-107">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}